/* eslint-disable no-underscore-dangle */
import { actionCreator } from 'utils';
import * as RollsOutTypes from '../types/rollOutTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    limit: 50,
    offset: 0,
    sort: {
        key: 'shipping_date',
        type: 'asc',
    },
    filters: {
        rollerBarcode: '',
        formId: '',
        formVersionId: '',
        jobId: '',
        quality: '',
        width: '',
        height: '',
        creationDate: [],
        state: undefined,
        machine_ids: undefined,
    },
    step: {
        loading: false,
        error: false,
        command: null,
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case RollsOutTypes.LOAD_ROLLS_OUT:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(RollsOutTypes.LOAD_ROLLS_OUT, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(RollsOutTypes.LOAD_ROLLS_OUT, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case RollsOutTypes.SET_ROLLS_OUT_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(RollsOutTypes.SET_ROLLS_OUT_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case RollsOutTypes.SET_ROLLS_OUT_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case RollsOutTypes.SET_ROLLS_OUT_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case RollsOutTypes.RESET_ROLLS_OUT_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case RollsOutTypes.TOGGLE_ROLLS_OUT_STATUS:
        return Object.assign({}, state, {
            step: {
                ...state.step,
                error: false,
                loading: action.data.rolls_out_id,
                command: action.data.step_state,
            },
        });

    case actionCreator(RollsOutTypes.TOGGLE_ROLLS_OUT_STATUS, 'res'):
        return Object.assign({}, state, {
            step: {
                ...state.step,
                loading: false,
                command: null,
            },
        });

    case actionCreator(RollsOutTypes.TOGGLE_ROLLS_OUT_STATUS, 'err'):
        return Object.assign({}, state, {
            step: {
                ...state.step,
                loading: false,
                error: true,
                command: null,
            },
        });

    case RollsOutTypes.CREATE_PALETTE_FROM_ROLLS_OUT:
        return Object.assign({}, state, {
            step: {
                ...state.step,
                error: false,
                loading: action.data._id,
                command: 'CREATE_PALETTE',
            },
        });

    case actionCreator(RollsOutTypes.CREATE_PALETTE_FROM_ROLLS_OUT, 'res'):
        return Object.assign({}, state, {
            step: {
                ...state.step,
                loading: false,
                command: null,
            },
        });

    case actionCreator(RollsOutTypes.CREATE_PALETTE_FROM_ROLLS_OUT, 'err'):
        return Object.assign({}, state, {
            step: {
                ...state.step,
                loading: false,
                error: true,
                command: null,
            },
        });

    default:
        return state;
    }
}
